/**
 * Georgian tax rates — the numbers, in one place.
 *
 * The 18% used to be written three ways: `total * 18 / 118` on the commercial
 * invoice, `revenue / (1 + 0.18)` on the reports tab, and `total / 1.18` in
 * the fiscal mock. They agreed; three spellings of one rate are three places
 * to forget the day it changes (audit, 2026-09-23 → consolidated 2026-09-25).
 *
 * Georgian retail prices INCLUDE VAT, so VAT is always the part inside a
 * total, never something added on top. The functions keep the invoice's own
 * arithmetic (×18 ÷118) so no invoice ever issued changes by a tetri.
 */

/** დღგ, in percent. */
export const VAT_PERCENT = 18
/** დღგ as a fraction. */
export const VAT_RATE = VAT_PERCENT / 100

/** მცირე ბიზნესის სტატუსი — 1% of turnover, declared monthly. */
export const SMALL_BUSINESS_RATE = 0.01

/** The VAT inside a VAT-inclusive amount (18/118 of it). Not rounded. */
export function vatInside(gross: number): number {
  return (gross * VAT_PERCENT) / (100 + VAT_PERCENT)
}

/** A VAT-inclusive amount without its VAT (100/118 of it). Not rounded. */
export function netOfVat(gross: number): number {
  return (gross * 100) / (100 + VAT_PERCENT)
}
